import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import { BlogCard } from "./blog";
import projImg1 from "../assets/img/portf.jpg";
import projImg2 from "../assets/img/business.jpg";
import projImg3 from "../assets/img/nike.jpg";
import projImg4 from "../assets/img/benefits-of-tech-for-kids-header_1_511x337.png";
import projImg5 from "../assets/img/1689442730181_511x337.jpeg";
import projImg6 from "../assets/img/TW.jpg";
import projImg7 from "../assets/img/1689834463009.jpeg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "Portfolio website",
      description: "Design & Development",
      imgUrl: projImg1,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "Landing Page",
      description: "Design & Development",
      imgUrl: projImg3,
    },
  ];
  const project2 = [
    {
      title: "Artificial Intelligence and Its Impact on Content Writing",
      link: "https://www.linkedin.com/pulse/artificial-intelligence-its-impact-content-writing-madu-kelechi/",
      imgUrl: projImg7,
      blog: "Navigate >>>",
    },
    {
      title: "Ways to Become better at Technical Writing",
      link: "https://01spirit.hashnode.dev/can-technical-writing-improve-your-development-career",
      imgUrl: projImg6,
      blog: "Navigate >>>",
    },
    {
      title: "Social Anxiety and it's effect in Tech",
      link: "https://dev.to/spiritdivine/social-anxiety-disorder-in-the-tech-ecospace-5fe7",
      imgUrl: projImg4,
      blog: "Navigate >>>",
    },
    {
      title: "Effects of AI in the Gaming World",
      link: "https://www.linkedin.com/pulse/game-changing-impact-artificial-intelligence-gaming-world-kelechi/",
      imgUrl: projImg5,
      blog: "Navigate >>>",
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Welcome to my project showcase, where I'm thrilled to share
                    a glimpse of my work across the realms of web development,
                    content creation, and cybersecurity. Each project represents
                    not just a piece of my expertise but a testament to my
                    commitment to excellence in these domains.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Software</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Blog Post</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {project2.map((project, index) => {
                            return <BlogCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
};
